import { createContextStore } from "@faire/web/ui/hooks/ContextStore";
import { useCallback } from "react";

const { useStore, Provider } = createContextStore({
  hiddenBrandTokens: new Array<string>(),
});

export const UserFeedbackContextStoreProvider = Provider;

export const useUserFeedbackContextStore = () => {
  const [{ hiddenBrandTokens }, setStore] = useStore(["hiddenBrandTokens"]);

  const addHiddenBrand = useCallback(
    (brandToken: string) => {
      if (!hiddenBrandTokens.includes(brandToken)) {
        setStore((prev) => ({
          hiddenBrandTokens: [...prev.hiddenBrandTokens, brandToken],
        }));
      }
    },
    [hiddenBrandTokens, setStore]
  );

  const removeHiddenBrand = useCallback(
    (brandToken: string) => {
      if (hiddenBrandTokens.includes(brandToken)) {
        setStore((prev) => ({
          hiddenBrandTokens: prev.hiddenBrandTokens.filter(
            (token) => token !== brandToken
          ),
        }));
      }
    },
    [hiddenBrandTokens, setStore]
  );

  return {
    hiddenBrandTokens,
    addHiddenBrand,
    removeHiddenBrand,
  };
};
